import { render, staticRenderFns } from "./category-selector.vue?vue&type=template&id=7f57d7a3&"
import script from "./category-selector.vue?vue&type=script&lang=js&"
export * from "./category-selector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports